<template>
    <select v-model="selected" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm" ref="input">
      <slot />
    </select>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['modelValue'],

        emits: ['update:modelValue'],

        data() {
            return {
                selected: this.modelValue,
            }
        },

        watch: {
            selected(selected) {
                this.$emit('update:modelValue', selected)
            },
        },

        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
        },
    })
</script>
